import React, {useEffect} from 'react';
import {Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import {useDispatch, useSelector} from "react-redux";
import {isCurrentUserMemberOf} from "../../../util/bbHelpers";
import Dashboard from "./routes/Dashboard";
import AdminExternalPage from "./routes/AdminExternal";
import AdminInsiderPage from "./routes/AdminInsider";
import ManageUsers from "./routes/ManageUsers";
import ManageClients from "./routes/ManageClients";
import {fetchAdminOKR, fetchCustomers, fetchUsers} from "../../../actions";
import AdminSocialPage from "./routes/AdminSocial/AdminSocialPage";
import BRCustomersTable from "../../../components/customBreachBits/admin/BRCustomersTable/BRCustomersTable";
import NewClientForm from "../../../containers/NewClientForm";

function PageRoutes({match}) {
    return(
        <Switch>
            {/*<Redirect exact from={`${match.url}`} to={`${match.url}`}/>*/}
            <Route path={`${match.url}/dashboard`} component={Dashboard}/>
            <Route path={`${match.url}/external`} component={AdminExternalPage}/>
            <Route path={`${match.url}/internal`} component={AdminInsiderPage}/>
            <Route path={`${match.url}/social`} component={AdminSocialPage}/>
            <Route path={`${match.url}/users`} component={ManageUsers}/>
            <Route path={`${match.url}/clients`} component={ManageClients}/>
            {/*<Route path={`${match.url}/entities`} component={BRCustomersTable}/>*/}
            {/*<Route path={`${match.url}/customers`} component={BRCustomersTable}/>*/}
            {/*<Route path={`${match.url}/dashboard`} component={NewClientForm}/>*/}
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
    );
}

const Pages = ({match}) => {
    const authUser = useSelector(({auth}) => auth.authUser);
    const {users, loadingUsers, loadingUsersError,} = useSelector(({users}) => users);
    const {okr, loadingAdminOKR, loadingAdminOKRError,}= useSelector(({admin})=>admin);
    const {customers, loadingCustomers, loadingCustomersError} = useSelector(({customer}) => customer);
    const dispatch = useDispatch();

    useEffect(()=>{
        if (customers == null && !loadingCustomers && !loadingCustomersError) {
            // console.log("Customers is empty, fetching from CIRTPages. numCustomers is ", numCustomers);
            dispatch(fetchCustomers());
        }

        if (users === null && !loadingUsers && !loadingUsersError){
            dispatch(fetchUsers());
        }

        if (okr === null && !loadingAdminOKR && !loadingAdminOKRError){
            dispatch(fetchAdminOKR());
        }

    },[dispatch, customers, users, loadingUsers, loadingCustomers, loadingCustomersError, loadingUsersError, okr, loadingAdminOKR, loadingAdminOKRError])


    if (isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff") || isCurrentUserMemberOf(authUser, "partner")) {
        return (
                <PageRoutes match={match}/>
        )
    } else {
        return (
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        )
    }
};

export default Pages;
